import { Injectable, TemplateRef } from '@angular/core';
import { ChartDataPoint, ChartSeriesDataPoint } from '@ndt/reports/shared/charts/chart-data-point-interface';
import { Subject } from 'rxjs';
import { ChartBase, defaultColorScheme } from '../chart-base';
import { ChartOptions } from '../models/chart-options';

@Injectable()
export class GraphTileService<T extends ChartSeriesDataPoint | ChartDataPoint> extends ChartBase<T> {
   $init = new Subject<void>();

   init(config: ChartOptions) {
      this.view = config.view;
      this.labels = !!config.labels;
      this.doughnut = !!config.doughnut;
      this.explodeSlices = !!config.explodeSlices;
      this.legend = !!config.legend;
      this.timeline = !!config.timeline;
      this.xAxisLabel = config.xAxisLabel ?? '';
      this.yAxisLabel = config.yAxisLabel ?? '';
      this.showXAxisLabel = !!config.showXAxisLabel;
      this.showYAxisLabel = !!config.showYAxisLabel;
      this.xAxisTickFormatting = config.xAxisTickFormatting ?? ((val: Date | string) => `${val}`);
      this.maxXAxisTickLength = config.maxXAxisTickLength ?? 8;
      this.xScaleMin = config.xScaleMin;
      this.xScaleMax = config.xScaleMax;
      this.data = (config.data ?? []) as T[];
      this.colorScheme = config.colorScheme ?? defaultColorScheme;
      this.customTooltipTemplateRef = config.customTooltipTemplateRef as TemplateRef<any>;
      this.customSeriesTooltipTemplateRef = config.customSeriesTooltipTemplateRef as TemplateRef<any>;
      this.$init.next();
   }
}
